export default __webpack_public_path__ + "static/syncstage-built-to-support-daw-abea0e1bfedb3a6a95bffb94937d93ca.png";